import Component from '../component';

export default class SidebarToggle extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$overlayElement = $('.sidebarToggle-overlay');

    this.handlePageLoad();
    this.bindEvents();
  }

  bindEvents() {
    this.handleTriggerClick = this.handleTriggerClick.bind(this);
    this.handleOverlayClick = this.handleOverlayClick.bind(this);
    this.handleOverlayTouchMove = this.handleOverlayTouchMove.bind(this);
    this.handlePageLoad = this.handlePageLoad.bind(this);

    this.$element.on('click.SidebarToggle', this.handleTriggerClick);
    this.$overlayElement.on('click.SidebarToggle', this.handleOverlayClick);
    this.$overlayElement.on(
      'touchmove.SidebarToggle',
      this.handleOverlayTouchMove
    );
    window.$document.on('turbolinks:load.SidebarToggle', this.handlePageLoad);
  }

  unbindEvents() {
    this.$element.off('click.SidebarToggle', this.handleTriggerClick);
    this.$overlayElement.off('click.SidebarToggle', this.handleOverlayClick);
    this.$overlayElement.off(
      'touchmove.SidebarToggle',
      this.handleOverlayTouchMove
    );
    window.$document.off('turbolinks:load.SidebarToggle', this.handlePageLoad);
  }

  handleTriggerClick() {
    window.$html.toggleClass('sidebarToggled');
  }

  handleOverlayClick() {
    window.$html.removeClass('sidebarToggled');
  }

  handlePageLoad() {
    window.$html.removeClass('sidebarToggled');
  }

  handleOverlayTouchMove(event) {
    event.preventDefault();
    event.stopPropagation();
  }
}
